import { Language } from '../../domain/entities/language';

const API_LANGUAGES: Readonly<Record<Language, string>> = {
  'es-ES': 'es',
  'es-EU': 'eu',
  'en-UK': 'en',
  'fr-FR': 'fr',
};

export function toApiLanguage(language: Language): string {
  return API_LANGUAGES[language];
}
